const addToLocalStorage = (mins) => {
    localStorage.setItem('minutes', JSON.stringify(mins));
}

const showDataFromLocalStorage = () => {
    const mins = localStorage.getItem('minutes');
    return JSON.parse(mins);
}

export { addToLocalStorage, showDataFromLocalStorage };